import { classNames } from 'libs/react';
import { Button } from 'components/Button';
import { ButtonGroup } from 'components/ButtonGroup';
import { Icon } from 'components/Icon';
import { React } from 'libs/react';
import './DealItemPickerOptionAlert.scss';
import { useModal } from 'components/modal/ModalStack';
/**
 * @component DealItemPickerOptionAlert
 * @since 1.0.0
 */
export function DealItemPickerOptionAlert(props) {
    const { style, item, relations } = Object.assign({ style: 'normal' }, props);
    const modal = useModal();
    /**
     * @function onAccept
     * @since 1.0.0
     * @hidden
     */
    function onAccept() {
        modal.dismiss();
        if (props.onAccept) {
            props.onAccept();
        }
    }
    /**
     * @function onDiscard
     * @since 1.0.0
     * @hidden
     */
    function onDiscard() {
        modal.dismiss();
        if (props.onDiscard) {
            props.onDiscard();
        }
    }
    const className = classNames('deal-item-picker-option-alert', 'deal-item-picker-option-alert--' + style, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "deal-item-picker-option-alert-body" },
            React.createElement("div", { className: "deal-item-picker-option-alert-section" },
                React.createElement("div", { className: "deal-item-picker-option-alert-title" }, t('Edit configuration')),
                React.createElement("div", { className: "deal-item-picker-option-alert-infos" }, t('Change to your existing configuration are necessary as a result of the options chosen. Please confirm the changed options by clicking “Accept Changes”.'))),
            React.createElement("div", { className: "deal-item-picker-option-alert-section" },
                React.createElement("div", { className: "deal-item-picker-option-alert-title" }, t('Edit configuration')),
                React.createElement("div", { className: "deal-item-picker-option-alert-table" },
                    React.createElement("table", null,
                        React.createElement("tbody", null,
                            React.createElement("tr", null,
                                React.createElement("td", { className: "deal-item-picker-option-alert-table-label" }, item.title)))))),
            React.createElement("div", { className: "deal-item-picker-option-alert-section" },
                React.createElement("div", { className: "deal-item-picker-option-alert-title" }, t('Required changes')),
                React.createElement("div", { className: "deal-item-picker-option-alert-table" },
                    React.createElement("table", null,
                        React.createElement("tbody", null, relations === null || relations === void 0 ? void 0 : relations.map((relation) => {
                            if (relation.type == 'CONDITIONAL') {
                                return (React.createElement("tr", { key: relation.id },
                                    React.createElement("td", { className: "deal-item-picker-option-alert-table-picto" },
                                        React.createElement(Icon, { value: "plus" })),
                                    React.createElement("td", { className: "deal-item-picker-option-alert-table-label" }, relation.relatedSaleItem.title)));
                            }
                            if (relation.type == 'INCOMPATIBLE') {
                                return (React.createElement("tr", { key: relation.id },
                                    React.createElement("td", { className: "deal-item-picker-option-alert-table-picto" },
                                        React.createElement(Icon, { value: "minus" })),
                                    React.createElement("td", { className: "deal-item-picker-option-alert-table-label" }, relation.relatedSaleItem.title)));
                            }
                        })))))),
        React.createElement("div", { className: "deal-item-picker-option-alert-foot" },
            React.createElement(ButtonGroup, { style: "space-between" },
                React.createElement(Button, { style: "plain", label: t('Discard Changes'), onPress: onDiscard }),
                React.createElement(Button, { style: "primary", label: t('Accept Changes'), onPress: onAccept })))));
}
